import { NavLink } from "../models/NavLink";
import { RouteItem } from "../models/RouteItem";
import {
  isApiKeysOpen,
  isCat15Open,
  isGoalSettingOpen,
  isScope3Open,
} from "./config";

export const CAT15_PATH = "/financed-emissions";
export const ONBOARDING_PATH = "/onboarding";

interface NavigationItem {
  path: string;
  title: string;
  image?: string;
  children?: NavigationItem[];
  sidebarHidden?: boolean;
}

const navigation: NavigationItem[] = [
  {
    path: "/overview",
    title: "Overview",
    image: "/img/overview.svg",
    children: [
      { path: "/overview/total-emissions", title: "Total-Emissions" },
      { path: "/overview/scope-1", title: "Scope-1-emissions" },
      { path: "/overview/scope-2", title: "Scope-2-emissions" },
      {
        path: "/overview/scope-3",
        title: "Scope-3-emissions",
        sidebarHidden: !isScope3Open,
      },
      { path: "/overview/other", title: "Others", sidebarHidden: true },
    ],
  },
  {
    path: "/emission",
    title: "Emission",
    image: "/img/input.svg",
    children: [
      { path: "/emission/add", title: "Add-Data" },
      { path: "/emission/import-data", title: "Import-Data" },
    ],
  },
  {
    path: "/eco-efficiency",
    title: "Eco-Efficiency",
    image: "/img/eco-efficiency.svg",
    children: [
      { path: "/eco-efficiency/dashboard", title: "Dashboard" },
      { path: "/eco-efficiency/add-data", title: "Add-Data" },
    ],
  },
  {
    path: "/goal-setting",
    title: "Goal-Setting",
    image: "/img/gps.svg",
    sidebarHidden: !isGoalSettingOpen,
    children: [
      { path: "/goal-setting/dashboard", title: "Dashboard" },
      { path: "/goal-setting/add-goal", title: "Add-Data" },
    ],
  },
  {
    path: "/report",
    title: "Report",
    image: "/img/report.svg",
    children: [
      { path: "/report/tgo-cfo", title: "Tgo-Cfo" },
      { path: "/report/summary", title: "Summary" },
    ],
  },
  {
    path: CAT15_PATH,
    title: "Financed-Emissions",
    image: "/img/financed-emissions.svg",
    sidebarHidden: !isCat15Open,
    children: [
      { path: "/financed-emissions/dashboard", title: "Dashboard" },
      { path: "/financed-emissions/borrowers", title: "Borrowers" },
      { path: "/financed-emissions/report", title: "Report" },
      {
        path: "/financed-emissions/needs-attention",
        title: "Needs-Attention",
        sidebarHidden: true,
      },
      { path: "/financed-emissions/my-data", title: "My-Data" },
    ],
  },
  {
    path: "/setting",
    title: "setting",
    image: "/img/framework-establishing.svg",
    children: [
      { path: "/setting/activities-template", title: "activity-templates" },
      { path: "/setting/economic-indicator", title: "Economic-Indicator" },
      { path: "/setting/files-management", title: "Files-Management" },
      { path: "/setting/access-control", title: "Access-Control" },
      { path: "/setting/business-structure", title: "Business-Structure" },
      {
        path: "/setting/api-keys",
        title: "API-Keys",
        sidebarHidden: !isApiKeysOpen,
      },
      {
        path: "/setting/accessility-and-permission",
        title: "Accessility-Permission",
        sidebarHidden: true,
      },
    ],
  },
  { path: "/account", title: "Account", image: "/img/account.svg", sidebarHidden: true },
  // Registered only so the return-visit breadcrumb resolves; sidebarHidden keeps it out of the nav menu.
  // The image is required, not decorative — Topbar renders <img src={props.img}> unconditionally and draws a broken icon without it.
  { path: ONBOARDING_PATH, title: "Onboarding", image: "/img/buildings.svg", sidebarHidden: true },
];

function toNavLinks(items: NavigationItem[]): NavLink[] {
  return items
    .filter((item) => !item.sidebarHidden)
    .map((item) => ({
      path: item.path,
      children: item.children ? toNavLinks(item.children) : undefined,
    }));
}

function flatten(items: NavigationItem[]): RouteItem[] {
  return items.flatMap((item) => [
    { path: item.path, title: item.title, image: item.image },
    ...(item.children ? flatten(item.children) : []),
  ]);
}

export const navLinks: NavLink[] = toNavLinks(navigation);

export const navLinksDataEntry: NavLink[] = [
  {
    path: "/emission",
    children: [{ path: "/emission/add" }],
  },
];

export const routes: RouteItem[] = flatten(navigation);
